// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelSelect } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { ALLOWED_GENDERS } from './constants';
import { useMountLogging } from '@/lib/reactHooks';

const Gender = props => {
  useMountLogging('Gender');
  const gender = useStoreState(({ form }) => form.gender);
  const genderOptions = ALLOWED_GENDERS.map(gender => ({
    text: getContent(`fieldValues.${gender}`),
    value: gender,
  }));

  return (
    <FloatingLabelSelect
      emptyOption={{ enabled: true }}
      id="gender"
      label={getContent('fieldLabels.gender')}
      name="gender"
      required={true}
      selectOptions={genderOptions}
      {...gender}
      {...props}
    />
  );
};

Gender.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { Gender };
